"use strict";
import classNames from "classnames";
import React from "react";
export const RainbowBar = ({ isTopRounded = true, size = "medium" }) => {
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: classNames("rainbow-bar", {
        "rainbow-bar--rounded-top": isTopRounded,
        "rainbow-bar--small": size === "small"
      })
    }
  );
};
export default RainbowBar;
